import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "formulario-modelo asignacion-roles" }
const _hoisted_2 = { class: "header-flex" }
const _hoisted_3 = { class: "acciones-header" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "tabs" }
const _hoisted_8 = {
  key: 0,
  class: "marco form-rol"
}
const _hoisted_9 = { class: "formulario-inicial" }
const _hoisted_10 = { class: "formulario-opcion" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "nota"
}
const _hoisted_13 = { class: "formulario-opcion" }
const _hoisted_14 = { class: "formulario-opcion" }
const _hoisted_15 = { class: "formulario-opcion col-span" }
const _hoisted_16 = { class: "botones" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "marco" }
const _hoisted_19 = {
  key: 0,
  class: "vacio-msg"
}
const _hoisted_20 = {
  key: 1,
  class: "tabla-roles"
}
const _hoisted_21 = { class: "td-name" }
const _hoisted_22 = { class: "td-label" }
const _hoisted_23 = { class: "td-acciones" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick", "disabled", "title"]
const _hoisted_27 = {
  key: 0,
  class: "marco"
}
const _hoisted_28 = { class: "formulario-inicial" }
const _hoisted_29 = { class: "formulario-opcion" }
const _hoisted_30 = { class: "formulario-opcion" }
const _hoisted_31 = { class: "formulario-opcion" }
const _hoisted_32 = { class: "botones" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "marco" }
const _hoisted_35 = { class: "marco-header--between" }
const _hoisted_36 = {
  key: 0,
  class: "conteo"
}
const _hoisted_37 = {
  key: 0,
  class: "vacio-msg"
}
const _hoisted_38 = {
  key: 1,
  class: "tabla-usuarios"
}
const _hoisted_39 = { class: "td-nombre" }
const _hoisted_40 = { class: "td-correo" }
const _hoisted_41 = { class: "td-roles" }
const _hoisted_42 = { class: "td-estado" }
const _hoisted_43 = { class: "td-accion" }
const _hoisted_44 = ["onClick", "disabled"]
const _hoisted_45 = ["onClick", "disabled"]
const _hoisted_46 = ["onClick", "disabled"]
const _hoisted_47 = ["onClick", "disabled"]
const _hoisted_48 = {
  key: 0,
  class: "marco form-rol"
}
const _hoisted_49 = { class: "formulario-inicial" }
const _hoisted_50 = { class: "formulario-opcion" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  key: 0,
  class: "nota"
}
const _hoisted_53 = {
  key: 1,
  class: "nota"
}
const _hoisted_54 = { class: "formulario-opcion" }
const _hoisted_55 = { class: "formulario-opcion" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = ["value"]
const _hoisted_58 = { class: "formulario-opcion col-span" }
const _hoisted_59 = { class: "botones" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { class: "marco" }
const _hoisted_62 = {
  key: 0,
  class: "vacio-msg"
}
const _hoisted_63 = {
  key: 1,
  class: "tabla-permisos"
}
const _hoisted_64 = { class: "td-pname" }
const _hoisted_65 = { class: "td-plabel" }
const _hoisted_66 = { class: "td-acciones" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["onClick", "disabled", "title"]
const _hoisted_69 = {
  key: 3,
  class: "modal-overlay"
}
const _hoisted_70 = { class: "modal-permisos" }
const _hoisted_71 = {
  key: 4,
  class: "modal-overlay"
}
const _hoisted_72 = { class: "modal-panel" }
const _hoisted_73 = { class: "modal-sub" }
const _hoisted_74 = {
  key: 0,
  class: "vacio-msg"
}
const _hoisted_75 = {
  key: 1,
  class: "roles-lista"
}
const _hoisted_76 = ["value"]
const _hoisted_77 = {
  class: "formulario-opcion",
  style: {"margin-top":"1rem"}
}
const _hoisted_78 = { class: "modal-footer" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = {
  key: 5,
  class: "modal-overlay"
}
const _hoisted_81 = { class: "modal-panel modal-panel--wide" }
const _hoisted_82 = { class: "modal-sub" }
const _hoisted_83 = {
  key: 0,
  class: "vacio-msg"
}
const _hoisted_84 = {
  key: 1,
  class: "vacio-msg"
}
const _hoisted_85 = {
  key: 2,
  class: "tabla-historial"
}

import { ref, onMounted } from 'vue'
import useAutenticar from '@/store/IngresoAutenticar'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import MensajeConfirmacion from '@/components/MensajeConfirmacion.vue'
import PermisosUsuario from '@/components/PermisosUsuario.vue'
import {
  listarRoles,
  crearRol,
  actualizarRol,
  eliminarRol,
  listarUsuarios,
  registrarUsuario,
  eliminarUsuario,
  actualizarEstadoUsuario,
  asignarRolesUsuario,
  historialRolesUsuario,
  listarPermisos,
  crearPermiso,
  actualizarPermiso,
  eliminarPermiso,
  listarModulos,
} from '@/services/RegistroUsuariosService'
import type { RolApi, AsignacionRolEntry, PermisoApiDetalle } from '@/services/RegistroUsuariosService'
import type { Usuario } from '@/interfaces/Usuario'
import { primerError } from '@/services/http'


export default /*@__PURE__*/_defineComponent({
  __name: 'AsignacionRolesView',
  setup(__props) {

/**
 * Administración de roles y matriz de permisos.
 *
 * Los roles de sistema no se pueden renombrar ni eliminar, pero sí cambiar sus
 * permisos. La lista enviada REEMPLAZA la anterior: omitir un permiso lo revoca.
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const auth = useAutenticar()
const flotanteVisible = ref(false)
const flotanteMensaje = ref('')
const flotanteTipo = ref<'positivo' | 'error'>('positivo')

function mostrarExito(msg: string) {
  flotanteMensaje.value = msg
  flotanteTipo.value = 'positivo'
  flotanteVisible.value = true
}
function mostrarError(msg: string) {
  flotanteMensaje.value = msg
  flotanteTipo.value = 'error'
  flotanteVisible.value = true
}

const confirmVisible  = ref(false)
const confirmTitulo   = ref('')
const confirmMensaje  = ref('')
const confirmTexto    = ref('Confirmar')
let   confirmCallback: (() => Promise<void>) | null = null

function pedirConfirmacion(titulo: string, mensaje: string, texto: string, cb: () => Promise<void>) {
  confirmTitulo.value  = titulo
  confirmMensaje.value = mensaje
  confirmTexto.value   = texto
  confirmCallback = cb
  confirmVisible.value = true
}

async function ejecutarConfirmacion() {
  confirmVisible.value = false
  if (confirmCallback) await confirmCallback()
  confirmCallback = null
}

const loadingInicial = ref(false)
const loadingAccion = ref(false)
const activeTab = ref<'roles' | 'usuarios' | 'permisos'>('roles')

function cambiarTab(tab: 'roles' | 'usuarios' | 'permisos') {
  activeTab.value = tab
  mostrarFormRol.value = false
  editandoRol.value = null
  mostrarFormRegistro.value = false
  mostrarFormPermiso.value = false
  editandoPermiso.value = null
}

const roles = ref<RolApi[]>([])
const mostrarFormRol = ref(false)
const editandoRol = ref<RolApi | null>(null)
const formRol = ref({ name: '', label: '', descripcion: '', nivel_aplicacion: 'institucional' })
const rolPermisos = ref<RolApi | null>(null)

function abrirFormNuevo() {
  editandoRol.value = null
  formRol.value = { name: '', label: '', descripcion: '', nivel_aplicacion: 'institucional' }
  mostrarFormRol.value = true
  rolPermisos.value = null
}

function abrirFormEditar(rol: RolApi) {
  editandoRol.value = rol
  formRol.value = {
    name: rol.name,
    label: rol.label,
    descripcion: rol.descripcion ?? '',
    nivel_aplicacion: rol.nivel_aplicacion ?? 'institucional',
  }
  mostrarFormRol.value = true
  rolPermisos.value = null
}

function cancelarFormRol() {
  mostrarFormRol.value = false
  editandoRol.value = null
}

async function guardarRol() {
  if (!formRol.value.name.trim() || !formRol.value.label.trim()) {
    mostrarError('El nombre y la etiqueta son obligatorios.')
    return
  }
  loadingAccion.value = true
  const eraEdicion = !!editandoRol.value
  try {
    if (editandoRol.value) {
      const payload: { name?: string; label?: string; descripcion?: string; nivel_aplicacion?: string } = {
        label: formRol.value.label,
        nivel_aplicacion: formRol.value.nivel_aplicacion,
      }
      if (formRol.value.descripcion) payload.descripcion = formRol.value.descripcion
      if (!editandoRol.value.es_sistema) payload.name = formRol.value.name
      const result = await actualizarRol(editandoRol.value.id, payload)
      if (!result.ok) { mostrarError(primerError(result, 'Error al actualizar el rol.')); return }
    } else {
      const payload: Parameters<typeof crearRol>[0] = {
        name: formRol.value.name,
        label: formRol.value.label,
        nivel_aplicacion: formRol.value.nivel_aplicacion,
      }
      if (formRol.value.descripcion) payload.descripcion = formRol.value.descripcion
      const result = await crearRol(payload)
      if (!result.ok) { mostrarError(primerError(result, 'Error al crear el rol.')); return }
    }
    mostrarFormRol.value = false
    editandoRol.value = null
    await cargarRoles()
    mostrarExito(eraEdicion ? 'Rol actualizado correctamente.' : 'Rol creado correctamente.')
  } finally {
    loadingAccion.value = false
  }
}

function borrarRol(rol: RolApi) {
  if (rol.es_sistema) return
  pedirConfirmacion(
    'Eliminar rol',
    `¿Eliminar el rol "${rol.label}"? Esta acción no se puede deshacer.`,
    'Eliminar',
    async () => {
      loadingAccion.value = true
      const result = await eliminarRol(rol.id)
      loadingAccion.value = false
      if (!result.ok) { mostrarError(primerError(result, 'Error al eliminar el rol.')); return }
      if (rolPermisos.value?.id === rol.id) rolPermisos.value = null
      await cargarRoles()
      mostrarExito('Rol eliminado.')
    }
  )
}

function abrirPermisos(rol: RolApi) {
  rolPermisos.value = rol
  mostrarFormRol.value = false
}
function cerrarPermisos() { rolPermisos.value = null }
function onPermisosGuardados() { cerrarPermisos(); mostrarExito('Permisos actualizados correctamente.') }

const usuarios = ref<Usuario[]>([])
const mostrarFormRegistro = ref(false)
const formUsuario = ref({ name: '', email: '', telephone: '' })

const usuarioEditandoRoles = ref<Usuario | null>(null)
const rolesSeleccionados = ref<string[]>([])
const observacionesAsignacion = ref('')

const usuarioHistorial = ref<Usuario | null>(null)
const historialEntries = ref<AsignacionRolEntry[]>([])
const cargandoHistorial = ref(false)

function rolesDeUsuario(u: Usuario): string {
  const lista = u.roles ?? []
  return lista.length > 0 ? lista.map(r => r.label || r.name).join(', ') : '—'
}

function formatFecha(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric' })
  } catch {
    return iso
  }
}

function abrirFormRegistro() { mostrarFormRegistro.value = true }
function cancelarFormRegistro() {
  mostrarFormRegistro.value = false
  formUsuario.value = { name: '', email: '', telephone: '' }
}

async function registrar() {
  if (!formUsuario.value.name.trim() || !formUsuario.value.email.trim()) {
    mostrarError('Nombre y correo son obligatorios.')
    return
  }
  if (!formUsuario.value.email.endsWith('@udi.edu.co')) {
    mostrarError('Solo se permiten correos @udi.edu.co.')
    return
  }
  loadingAccion.value = true
  const result = await registrarUsuario({
    name: formUsuario.value.name,
    email: formUsuario.value.email,
    ...(formUsuario.value.telephone.trim() ? { telephone: formUsuario.value.telephone } : {}),
  })
  if (!result.ok) {
    loadingAccion.value = false
    mostrarError(primerError(result, 'Error al registrar el usuario.'))
    return
  }

  // Director de Programa: asignar automáticamente el rol Docente de Calidad
  const esDirector = auth.tienePermiso('usuarios.crear') && !auth.tienePermiso('usuarios.ver')
  if (esDirector && result.data?.id) {
    const docenteRol = roles.value.find(r => r.label === 'Docente de Calidad')
    if (docenteRol) {
      await asignarRolesUsuario(result.data.id, [docenteRol.name])
    }
  }

  loadingAccion.value = false
  mostrarExito(`Usuario ${formUsuario.value.email} registrado correctamente.`)
  cancelarFormRegistro()
  await cargarUsuarios()
}

function eliminarUsuarioAcc(id: number) {
  pedirConfirmacion(
    'Eliminar usuario',
    '¿Eliminar este usuario? Esta acción no se puede deshacer.',
    'Eliminar',
    async () => {
      loadingAccion.value = true
      const result = await eliminarUsuario(id)
      loadingAccion.value = false
      if (!result.ok) { mostrarError(primerError(result, 'Error al eliminar el usuario.')); return }
      mostrarExito('Usuario eliminado.')
      await cargarUsuarios()
    }
  )
}

function toggleEstado(u: Usuario) {
  const nuevoEstado = u.estado === 'inactivo' ? 'activo' : 'inactivo'
  const accion = nuevoEstado === 'activo' ? 'Activar' : 'Desactivar'
  pedirConfirmacion(
    `${accion} usuario`,
    `¿${accion} a ${u.name}?`,
    accion,
    async () => {
      loadingAccion.value = true
      const result = await actualizarEstadoUsuario(u.id!, nuevoEstado)
      loadingAccion.value = false
      if (!result.ok) { mostrarError(primerError(result, `Error al ${accion.toLowerCase()} el usuario.`)); return }
      mostrarExito(`Usuario ${nuevoEstado === 'activo' ? 'activado' : 'desactivado'} correctamente.`)
      await cargarUsuarios()
    }
  )
}

function abrirModalRoles(u: Usuario) {
  usuarioEditandoRoles.value = u
  rolesSeleccionados.value = (u.roles ?? []).map(r => r.name)
  observacionesAsignacion.value = ''
}
function cerrarModalRoles() { usuarioEditandoRoles.value = null }

async function guardarRolesUsuario() {
  if (!usuarioEditandoRoles.value) return
  loadingAccion.value = true
  const result = await asignarRolesUsuario(
    usuarioEditandoRoles.value.id!,
    rolesSeleccionados.value,
    observacionesAsignacion.value.trim() || undefined,
  )
  loadingAccion.value = false
  if (!result.ok) { mostrarError(primerError(result, 'Error al asignar los roles.')); return }

  const idx = usuarios.value.findIndex(u => u.id === usuarioEditandoRoles.value!.id)
  if (idx !== -1) {
    const rolesAsignados = roles.value
      .filter(r => rolesSeleccionados.value.includes(r.name))
      .map(r => ({ id: r.id, name: r.name, label: r.label, nivel_aplicacion: r.nivel_aplicacion, es_sistema: r.es_sistema }))
    usuarios.value[idx] = { ...usuarios.value[idx], roles: rolesAsignados }
  }

  cerrarModalRoles()
  mostrarExito('Roles actualizados correctamente.')
  cargarUsuarios() 
}

async function abrirHistorial(u: Usuario) {
  usuarioHistorial.value = u
  historialEntries.value = []
  cargandoHistorial.value = true
  historialEntries.value = await historialRolesUsuario(u.id!)
  cargandoHistorial.value = false
}
function cerrarHistorial() { usuarioHistorial.value = null; historialEntries.value = [] }

const permisos = ref<PermisoApiDetalle[]>([])
const modulos = ref<{ id: number; nombre: string }[]>([])
const mostrarFormPermiso = ref(false)
const editandoPermiso = ref<PermisoApiDetalle | null>(null)
const formPermiso = ref({ name: '', label: '', descripcion: '', modulo_id: null as number | null })

function abrirFormPermisoNuevo() {
  editandoPermiso.value = null
  formPermiso.value = { name: '', label: '', descripcion: '', modulo_id: null }
  mostrarFormPermiso.value = true
}

function abrirFormPermisoEditar(p: PermisoApiDetalle) {
  editandoPermiso.value = p
  formPermiso.value = {
    name: p.name,
    label: p.label,
    descripcion: p.descripcion ?? '',
    modulo_id: p.modulo_id,
  }
  mostrarFormPermiso.value = true
}

function cancelarFormPermiso() {
  mostrarFormPermiso.value = false
  editandoPermiso.value = null
}

async function guardarPermiso() {
  if (!formPermiso.value.label.trim()) {
    mostrarError('La etiqueta es obligatoria.')
    return
  }
  if (!formPermiso.value.modulo_id) {
    mostrarError('Debe seleccionar un módulo.')
    return
  }
  if (!editandoPermiso.value && !formPermiso.value.name.trim()) {
    mostrarError('La clave es obligatoria.')
    return
  }
  loadingAccion.value = true
  const eraEdicion = !!editandoPermiso.value
  try {
    if (editandoPermiso.value) {
      const payload: Parameters<typeof actualizarPermiso>[1] = {
        label: formPermiso.value.label,
      }
      if (formPermiso.value.descripcion.trim()) payload.descripcion = formPermiso.value.descripcion
      if (!editandoPermiso.value.es_sistema) {
        payload.name = formPermiso.value.name
        payload.modulo_id = formPermiso.value.modulo_id!
      }
      const result = await actualizarPermiso(editandoPermiso.value.id, payload)
      if (!result.ok) { mostrarError(primerError(result, 'Error al actualizar el permiso.')); return }
    } else {
      const result = await crearPermiso({
        name: formPermiso.value.name,
        label: formPermiso.value.label,
        modulo_id: formPermiso.value.modulo_id!,
        ...(formPermiso.value.descripcion.trim() ? { descripcion: formPermiso.value.descripcion } : {}),
      })
      if (!result.ok) { mostrarError(primerError(result, 'Error al crear el permiso.')); return }
    }
    mostrarFormPermiso.value = false
    editandoPermiso.value = null
    await cargarPermisos()
    mostrarExito(eraEdicion ? 'Permiso actualizado correctamente.' : 'Permiso creado correctamente.')
  } finally {
    loadingAccion.value = false
  }
}

function borrarPermiso(p: PermisoApiDetalle) {
  if (p.es_sistema) return
  pedirConfirmacion(
    'Eliminar permiso',
    `¿Eliminar el permiso "${p.label}"? Esta acción no se puede deshacer.`,
    'Eliminar',
    async () => {
      loadingAccion.value = true
      const result = await eliminarPermiso(p.id)
      loadingAccion.value = false
      if (!result.ok) { mostrarError(primerError(result, 'Error al eliminar el permiso.')); return }
      await cargarPermisos()
      mostrarExito('Permiso eliminado.')
    }
  )
}

async function cargarRoles() { roles.value = await listarRoles() }
async function cargarUsuarios() { usuarios.value = await listarUsuarios() }
async function cargarPermisos() { permisos.value = await listarPermisos() }
async function cargarModulos() { modulos.value = await listarModulos() }

async function cargar() {
  loadingInicial.value = true
  await Promise.all([cargarRoles(), cargarUsuarios(), cargarPermisos(), cargarModulos()])
  loadingInicial.value = false
  if (!auth.tienePermiso('roles.ver')) {
    activeTab.value = 'usuarios'
  }
}

onMounted(cargar)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingOverlay, {
      visible: loadingInicial.value,
      message: "Cargando..."
    }, null, 8, ["visible"]),
    _createVNode(LoadingOverlay, {
      visible: loadingAccion.value,
      message: "Procesando..."
    }, null, 8, ["visible"]),
    _createVNode(MensajeFlotante, {
      visible: flotanteVisible.value,
      mensaje: flotanteMensaje.value,
      tipo: flotanteTipo.value,
      onCerrar: _cache[0] || (_cache[0] = ($event: any) => (flotanteVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"]),
    _createVNode(MensajeConfirmacion, {
      visible: confirmVisible.value,
      title: confirmTitulo.value,
      message: confirmMensaje.value,
      confirmText: confirmTexto.value,
      cancelText: "Cancelar",
      onConfirm: ejecutarConfirmacion,
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (confirmVisible.value = false))
    }, null, 8, ["visible", "title", "message", "confirmText"]),
    _createElementVNode("div", _hoisted_2, [
      _cache[18] || (_cache[18] = _createElementVNode("div", null, [
        _createElementVNode("h1", null, "Gestión de Usuarios"),
        _createElementVNode("p", { class: "header-sub" }, "Administra roles, permisos y cuentas del sistema")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (activeTab.value === 'roles' && (_unref(auth).tienePermiso('roles.gestionar')))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn guardar",
              onClick: abrirFormNuevo,
              disabled: loadingAccion.value
            }, " Nuevo rol ", 8, _hoisted_4))
          : _createCommentVNode("", true),
        (activeTab.value === 'usuarios' && !mostrarFormRegistro.value && (_unref(auth).tienePermiso('usuarios.crear')))
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn guardar",
              onClick: abrirFormRegistro,
              disabled: loadingAccion.value
            }, " Registrar usuario ", 8, _hoisted_5))
          : _createCommentVNode("", true),
        (activeTab.value === 'permisos' && !mostrarFormPermiso.value && (_unref(auth).tienePermiso('permisos.asignar')))
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "btn guardar",
              onClick: abrirFormPermisoNuevo,
              disabled: loadingAccion.value
            }, " Nuevo permiso ", 8, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_unref(auth).tienePermiso('roles.ver'))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["tab-btn", { activa: activeTab.value === 'roles' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (cambiarTab('roles')))
          }, " Roles ", 2))
        : _createCommentVNode("", true),
      (_unref(auth).tienePermiso('usuarios.ver') || _unref(auth).tienePermiso('usuarios.crear'))
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: _normalizeClass(["tab-btn", { activa: activeTab.value === 'usuarios' }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (cambiarTab('usuarios')))
          }, " Usuarios ", 2))
        : _createCommentVNode("", true),
      (_unref(auth).tienePermiso('permisos.asignar'))
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: _normalizeClass(["tab-btn", { activa: activeTab.value === 'permisos' }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (cambiarTab('permisos')))
          }, " Permisos ", 2))
        : _createCommentVNode("", true)
    ]),
    (activeTab.value === 'roles')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (mostrarFormRol.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("h2", null, _toDisplayString(editandoRol.value ? 'Editar rol' : 'Nuevo rol'), 1),
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "divider" }, null, -1)),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", null, "Nombre interno", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formRol.value.name) = $event)),
                      placeholder: "Ej: Evaluador",
                      disabled: !!editandoRol.value?.es_sistema
                    }, null, 8, _hoisted_11), [
                      [_vModelText, formRol.value.name]
                    ]),
                    (editandoRol.value?.es_sistema)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, " No se puede modificar el nombre de un rol de sistema. "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", null, "Etiqueta", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formRol.value.label) = $event)),
                      placeholder: "Ej: Evaluador de programas"
                    }, null, 512), [
                      [_vModelText, formRol.value.label]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[22] || (_cache[22] = _createElementVNode("label", null, "Nivel de aplicación", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formRol.value.nivel_aplicacion) = $event))
                    }, _cache[21] || (_cache[21] = [
                      _createElementVNode("option", { value: "institucional" }, "Institucional", -1),
                      _createElementVNode("option", { value: "programas" }, "Programas", -1),
                      _createElementVNode("option", { value: "ambos" }, "Ambos", -1)
                    ]), 512), [
                      [_vModelSelect, formRol.value.nivel_aplicacion]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", null, [
                      _createTextVNode("Descripción "),
                      _createElementVNode("span", { class: "nota-opt" }, "(opcional)")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formRol.value.descripcion) = $event)),
                      placeholder: "Descripción del rol"
                    }, null, 512), [
                      [_vModelText, formRol.value.descripcion]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    class: "btn guardar",
                    onClick: cancelarFormRol
                  }, "Cancelar"),
                  _createElementVNode("button", {
                    class: "btn guardar",
                    onClick: guardarRol,
                    disabled: loadingAccion.value
                  }, _toDisplayString(loadingAccion.value ? 'Guardando...' : (editandoRol.value ? 'Actualizar' : 'Crear rol')), 9, _hoisted_17)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            (roles.value.length === 0 && !loadingInicial.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, "No hay roles registrados."))
              : (_openBlock(), _createElementBlock("table", _hoisted_20, [
                  _cache[25] || (_cache[25] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Roles"),
                      _createElementVNode("th", null, "Etiqueta"),
                      _createElementVNode("th")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (rol) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: rol.id,
                        class: _normalizeClass({ 'fila-activa': rolPermisos.value?.id === rol.id })
                      }, [
                        _createElementVNode("td", _hoisted_21, _toDisplayString(rol.name), 1),
                        _createElementVNode("td", _hoisted_22, _toDisplayString(rol.label), 1),
                        _createElementVNode("td", _hoisted_23, [
                          (_unref(auth).tienePermiso('roles.gestionar'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn guardar btn-sm",
                                onClick: ($event: any) => (abrirFormEditar(rol))
                              }, "Editar", 8, _hoisted_24))
                            : _createCommentVNode("", true),
                          (_unref(auth).tienePermiso('roles.gestionar'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn guardar btn-sm",
                                onClick: ($event: any) => (abrirPermisos(rol))
                              }, "Permisos", 8, _hoisted_25))
                            : _createCommentVNode("", true),
                          (_unref(auth).tienePermiso('roles.gestionar'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "btn salir btn-sm",
                                onClick: ($event: any) => (borrarRol(rol)),
                                disabled: rol.es_sistema || loadingAccion.value,
                                title: rol.es_sistema ? 'No se puede eliminar un rol de sistema' : ''
                              }, " Eliminar ", 8, _hoisted_26))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    }), 128))
                  ])
                ]))
          ])
        ], 64))
      : _createCommentVNode("", true),
    (activeTab.value === 'usuarios')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (mostrarFormRegistro.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _cache[29] || (_cache[29] = _createElementVNode("h2", null, "Registrar nuevo usuario", -1)),
                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "divider" }, null, -1)),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[26] || (_cache[26] = _createElementVNode("label", null, "Nombre", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formUsuario.value.name) = $event)),
                      placeholder: "Nombre completo"
                    }, null, 512), [
                      [_vModelText, formUsuario.value.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _cache[27] || (_cache[27] = _createElementVNode("label", null, "Correo institucional", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formUsuario.value.email) = $event)),
                      placeholder: "usuario@udi.edu.co"
                    }, null, 512), [
                      [_vModelText, formUsuario.value.email]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _cache[28] || (_cache[28] = _createElementVNode("label", null, [
                      _createTextVNode("Teléfono "),
                      _createElementVNode("span", { class: "nota-opt" }, "(opcional)")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formUsuario.value.telephone) = $event)),
                      placeholder: "Ej: 3001234567"
                    }, null, 512), [
                      [_vModelText, formUsuario.value.telephone]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("button", {
                    class: "btn guardar",
                    onClick: cancelarFormRegistro
                  }, "Cancelar"),
                  _createElementVNode("button", {
                    class: "btn guardar",
                    onClick: registrar,
                    disabled: loadingAccion.value
                  }, _toDisplayString(loadingAccion.value ? 'Registrando...' : 'Registrar usuario'), 9, _hoisted_33)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _cache[31] || (_cache[31] = _createElementVNode("h2", null, "Usuarios registrados", -1)),
              (usuarios.value.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(usuarios.value.length) + " " + _toDisplayString(usuarios.value.length === 1 ? 'usuario' : 'usuarios'), 1))
                : _createCommentVNode("", true)
            ]),
            (usuarios.value.length === 0 && !loadingInicial.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_37, "No hay usuarios registrados."))
              : (_openBlock(), _createElementBlock("table", _hoisted_38, [
                  _cache[32] || (_cache[32] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Nombre"),
                      _createElementVNode("th", null, "Correo"),
                      _createElementVNode("th", null, "Roles"),
                      _createElementVNode("th", null, "Estado"),
                      _createElementVNode("th")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usuarios.value, (u) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: u.id
                      }, [
                        _createElementVNode("td", _hoisted_39, _toDisplayString(u.name), 1),
                        _createElementVNode("td", _hoisted_40, _toDisplayString(u.email), 1),
                        _createElementVNode("td", _hoisted_41, _toDisplayString(rolesDeUsuario(u)), 1),
                        _createElementVNode("td", _hoisted_42, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge-estado", u.estado === 'inactivo' ? 'badge-estado--inactivo' : 'badge-estado--activo'])
                          }, _toDisplayString(u.estado === 'inactivo' ? 'Inactivo' : 'Activo'), 3)
                        ]),
                        _createElementVNode("td", _hoisted_43, [
                          (_unref(auth).tienePermiso('usuarios.asignar_roles'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn guardar btn-sm",
                                onClick: ($event: any) => (abrirModalRoles(u)),
                                disabled: loadingAccion.value
                              }, "Roles", 8, _hoisted_44))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "btn guardar btn-sm",
                            onClick: ($event: any) => (abrirHistorial(u)),
                            disabled: loadingAccion.value
                          }, "Historial", 8, _hoisted_45),
                          (_unref(auth).tienePermiso('usuarios.editar'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn guardar btn-sm",
                                onClick: ($event: any) => (toggleEstado(u)),
                                disabled: loadingAccion.value
                              }, _toDisplayString(u.estado === 'inactivo' ? 'Activar' : 'Desactivar'), 9, _hoisted_46))
                            : _createCommentVNode("", true),
                          (_unref(auth).tienePermiso('usuarios.eliminar'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "btn salir btn-sm",
                                onClick: ($event: any) => (eliminarUsuarioAcc(u.id!)),
                                disabled: loadingAccion.value
                              }, " Eliminar ", 8, _hoisted_47))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
          ])
        ], 64))
      : _createCommentVNode("", true),
    (activeTab.value === 'permisos')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (mostrarFormPermiso.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _createElementVNode("h2", null, _toDisplayString(editandoPermiso.value ? 'Editar permiso' : 'Nuevo permiso'), 1),
                _cache[38] || (_cache[38] = _createElementVNode("div", { class: "divider" }, null, -1)),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _cache[33] || (_cache[33] = _createElementVNode("label", null, "Clave interna", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formPermiso.value.name) = $event)),
                      placeholder: "Ej: reportes.exportar",
                      disabled: !!editandoPermiso.value?.es_sistema
                    }, null, 8, _hoisted_51), [
                      [_vModelText, formPermiso.value.name]
                    ]),
                    (editandoPermiso.value?.es_sistema)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_52, " No se puede modificar la clave de un permiso de sistema. "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_53, "Formato: recurso.accion en minúsculas"))
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _cache[34] || (_cache[34] = _createElementVNode("label", null, "Etiqueta", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formPermiso.value.label) = $event)),
                      placeholder: "Ej: Exportar reportes"
                    }, null, 512), [
                      [_vModelText, formPermiso.value.label]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _cache[36] || (_cache[36] = _createElementVNode("label", null, "Módulo", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formPermiso.value.modulo_id) = $event)),
                      disabled: !!editandoPermiso.value?.es_sistema
                    }, [
                      _cache[35] || (_cache[35] = _createElementVNode("option", {
                        value: null,
                        disabled: ""
                      }, "Seleccione un módulo", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modulos.value, (m) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: m.id,
                          value: m.id
                        }, _toDisplayString(m.nombre), 9, _hoisted_57))
                      }), 128))
                    ], 8, _hoisted_56), [
                      [_vModelSelect, formPermiso.value.modulo_id]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _cache[37] || (_cache[37] = _createElementVNode("label", null, [
                      _createTextVNode("Descripción "),
                      _createElementVNode("span", { class: "nota-opt" }, "(opcional)")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formPermiso.value.descripcion) = $event)),
                      placeholder: "Descripción del permiso"
                    }, null, 512), [
                      [_vModelText, formPermiso.value.descripcion]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("button", {
                    class: "btn guardar",
                    onClick: cancelarFormPermiso
                  }, "Cancelar"),
                  _createElementVNode("button", {
                    class: "btn guardar",
                    onClick: guardarPermiso,
                    disabled: loadingAccion.value
                  }, _toDisplayString(loadingAccion.value ? 'Guardando...' : (editandoPermiso.value ? 'Actualizar' : 'Crear permiso')), 9, _hoisted_60)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_61, [
            (permisos.value.length === 0 && !loadingInicial.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_62, "No hay permisos registrados."))
              : (_openBlock(), _createElementBlock("table", _hoisted_63, [
                  _cache[39] || (_cache[39] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Clave"),
                      _createElementVNode("th", null, "Etiqueta"),
                      _createElementVNode("th")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permisos.value, (p) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: p.id
                      }, [
                        _createElementVNode("td", _hoisted_64, _toDisplayString(p.name), 1),
                        _createElementVNode("td", _hoisted_65, _toDisplayString(p.label), 1),
                        _createElementVNode("td", _hoisted_66, [
                          (_unref(auth).tienePermiso('permisos.asignar'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn guardar btn-sm",
                                onClick: ($event: any) => (abrirFormPermisoEditar(p))
                              }, "Editar", 8, _hoisted_67))
                            : _createCommentVNode("", true),
                          (_unref(auth).tienePermiso('permisos.asignar'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn salir btn-sm",
                                onClick: ($event: any) => (borrarPermiso(p)),
                                disabled: p.es_sistema || loadingAccion.value,
                                title: p.es_sistema ? 'No se puede eliminar un permiso de sistema' : ''
                              }, " Eliminar ", 8, _hoisted_68))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
          ])
        ], 64))
      : _createCommentVNode("", true),
    (rolPermisos.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _createVNode(PermisosUsuario, {
              "id-rol": rolPermisos.value.id,
              "rol-label": rolPermisos.value.label,
              onGuardado: onPermisosGuardados,
              onCerrar: cerrarPermisos
            }, null, 8, ["id-rol", "rol-label"])
          ])
        ]))
      : _createCommentVNode("", true),
    (usuarioEditandoRoles.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", { class: "modal-header" }, [
              _cache[40] || (_cache[40] = _createElementVNode("h3", null, "Asignar roles", -1)),
              _createElementVNode("button", {
                class: "btn-cerrar",
                onClick: cerrarModalRoles,
                "aria-label": "Cerrar"
              }, "✕")
            ]),
            _createElementVNode("p", _hoisted_73, _toDisplayString(usuarioEditandoRoles.value.name) + " · " + _toDisplayString(usuarioEditandoRoles.value.email), 1),
            (roles.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_74, "Cargando roles..."))
              : (_openBlock(), _createElementBlock("div", _hoisted_75, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (r) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: r.id,
                      class: "rol-opcion"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        value: r.name,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((rolesSeleccionados).value = $event))
                      }, null, 8, _hoisted_76), [
                        [_vModelCheckbox, rolesSeleccionados.value]
                      ]),
                      _createElementVNode("span", null, _toDisplayString(r.label || r.name), 1)
                    ]))
                  }), 128))
                ])),
            _createElementVNode("div", _hoisted_77, [
              _cache[41] || (_cache[41] = _createElementVNode("label", null, [
                _createTextVNode("Observaciones "),
                _createElementVNode("span", { class: "nota-opt" }, "(opcional)")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((observacionesAsignacion).value = $event)),
                placeholder: "Motivo del cambio"
              }, null, 512), [
                [_vModelText, observacionesAsignacion.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("button", {
                class: "btn guardar",
                onClick: cerrarModalRoles
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "btn guardar",
                onClick: guardarRolesUsuario,
                disabled: loadingAccion.value
              }, _toDisplayString(loadingAccion.value ? 'Guardando...' : 'Guardar'), 9, _hoisted_79)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (usuarioHistorial.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", { class: "modal-header" }, [
              _cache[42] || (_cache[42] = _createElementVNode("h3", null, "Historial de roles", -1)),
              _createElementVNode("button", {
                class: "btn-cerrar",
                onClick: cerrarHistorial,
                "aria-label": "Cerrar"
              }, "✕")
            ]),
            _createElementVNode("p", _hoisted_82, _toDisplayString(usuarioHistorial.value.name) + " · " + _toDisplayString(usuarioHistorial.value.email), 1),
            (cargandoHistorial.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_83, "Cargando historial..."))
              : (historialEntries.value.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_84, "Sin historial de roles."))
                : (_openBlock(), _createElementBlock("table", _hoisted_85, [
                    _cache[43] || (_cache[43] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Fecha"),
                        _createElementVNode("th", null, "Rol"),
                        _createElementVNode("th", null, "Asignado por"),
                        _createElementVNode("th", null, "Observaciones")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historialEntries.value, (entry) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: entry.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(formatFecha(entry.created_at)), 1),
                          _createElementVNode("td", null, _toDisplayString(entry.role?.label || entry.role?.name), 1),
                          _createElementVNode("td", null, _toDisplayString(entry.autor?.name), 1),
                          _createElementVNode("td", null, _toDisplayString(entry.observaciones || '—'), 1)
                        ]))
                      }), 128))
                    ])
                  ])),
            _createElementVNode("div", { class: "modal-footer" }, [
              _createElementVNode("button", {
                class: "btn guardar",
                onClick: cerrarHistorial
              }, "Cerrar")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})